import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiPut, apiPutFile } from './api';
import { IEmployeeAvailableTool } from '../types/services';
import { IToolData, IUpdateBulkToolStateDTO, IUpdateToolConditionDTO } from '../types/products';
import { TToolHistoryResponse } from 'types/toolHistory.types';
const { REACT_APP_SUBSCRIPTION } = process.env;

/**
 * Obtiene la lista de herramientas
 * @returns Promise con la lista de herramientas
 */
export const getToolsListing = async (key: string): Promise<IToolData[]> => {
  return apiGet<AxiosRequestConfig, IToolData[]>(`${REACT_APP_SUBSCRIPTION}${key}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateToolCondition = async (body: IUpdateToolConditionDTO): Promise<void> => {
  return apiPut<AxiosRequestConfig, { productId: number; toolConditionId: number; comments: string }, void>(
    `${REACT_APP_SUBSCRIPTION}/tool-condition/backoffice/set-condition`,
    body
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateToolState = async (formData: FormData): Promise<void> => {
  return apiPutFile<AxiosRequestConfig, void>(`${REACT_APP_SUBSCRIPTION}/tool-status/backoffice/set-status`, formData)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateBulkToolState = async (formData: FormData): Promise<void> => {
  return apiPutFile<AxiosRequestConfig, IUpdateBulkToolStateDTO, void>(
    `${REACT_APP_SUBSCRIPTION}/tool-status/bulk/backoffice/set-status`,
    formData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getProductById = async (productId: string): Promise<IToolData> => {
  return apiGet<AxiosRequestConfig, IToolData>(
    `${REACT_APP_SUBSCRIPTION}/backoffice-tools-view/internal/general/${productId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getToolHistory = async (productId: string): Promise<TToolHistoryResponse> => {
  return apiGet<AxiosRequestConfig, TToolHistoryResponse>(
    `${REACT_APP_SUBSCRIPTION}/backoffice-tools-view/internal/history/${productId}`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};


export const updateToolInspection = async (formData: FormData): Promise<void> => {
  return apiPutFile<AxiosRequestConfig, void>(
    `${REACT_APP_SUBSCRIPTION}/tool-inspection/backoffice/set-inspection`,
    formData
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const createPdfToolInformation = async (productId: string): Promise<string> => {
  return apiPost<AxiosRequestConfig, void>(
    `${REACT_APP_SUBSCRIPTION}/backoffice-tools-view/inspection-report/${productId}`
  )
    .then(response => Promise.resolve(response?.data?.url))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getEmployeeTools = async (userId: string, useHistoryParam: string): Promise<IEmployeeAvailableTool[]> => {
  const idNum = Number(userId);
  if (!Number.isFinite(idNum)) {
    return [];
  }
  const pathSegment = encodeURIComponent(JSON.stringify([idNum]));
  const url = `${REACT_APP_SUBSCRIPTION}/assignment/user-assingments/${pathSegment}?useHistory=${useHistoryParam}`;
  return apiGet<AxiosRequestConfig, IEmployeeAvailableTool[]>(url)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};